export default __webpack_public_path__ + "static/databox-af297cd36a6bb7a3186a080518d4d7eb.png";